"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleAjvErrors = void 0;
const files_errors_1 = require("./files.errors");
function requiredPermissionsErrorHandler(error, errors, sceneConfig) {
    const requiredPermissions = sceneConfig.requiredPermissions;
    const isRequiredPermissionsError = (err) => getPropertyWithError(err) === 'requiredPermissions';
    switch (error.keyword) {
        case 'enum': {
            const wrongPermissions = errors
                .filter((err) => err.keyword === 'enum' && isRequiredPermissionsError(err))
                .flatMap(({ instancePath }) => instancePath.split('/').slice(-1))
                .map((i) => requiredPermissions[i]);
            throw new files_errors_1.UnknownRequiredPermissionsError(wrongPermissions);
        }
        case 'uniqueItems': {
            const duplicatedRequiredPermissions = errors
                .filter((err) => err.keyword === 'uniqueItems' && isRequiredPermissionsError(err))
                .flatMap(({ params: { i } }) => requiredPermissions[i]);
            throw new files_errors_1.DuplicatedRequiredPermissionsError(duplicatedRequiredPermissions);
        }
    }
}
function allowedMediaHostnamesErrorHandler(error) {
    const { keyword, params } = error;
    // When the allowedMediaHostnames is null or an empty array, the property is missing.
    if ((keyword === 'type' && params.type === 'array') || keyword === 'minItems')
        throw new files_errors_1.AllowedMediaHostnameIsEmptyOrInvalidError();
}
const propertyHandlers = {
    requiredPermissions: requiredPermissionsErrorHandler,
    allowedMediaHostnames: allowedMediaHostnamesErrorHandler
};
const getPropertyWithError = ({ instancePath }) => {
    const [property] = instancePath.split('/').slice(1);
    return property;
};
const handleAjvError = (error, errors, sceneConfig) => {
    const { instancePath, keyword } = error;
    if (!instancePath) {
        switch (keyword) {
            case 'required': {
                const missingProperties = errors
                    .filter(({ keyword }) => keyword === 'required')
                    .map(({ params }) => params.missingProperty);
                throw new files_errors_1.MissingRequiredPropertiesError(missingProperties);
            }
            default:
                return;
        }
    }
    const property = getPropertyWithError(error);
    if (!property || !(property in propertyHandlers))
        return;
    propertyHandlers[property](error, errors, sceneConfig);
};
function handleAjvErrors(sceneConfig, errors) {
    errors === null || errors === void 0 ? void 0 : errors.forEach((error) => handleAjvError(error, errors, sceneConfig));
    throw new files_errors_1.InvalidSceneConfigFileError(errors);
}
exports.handleAjvErrors = handleAjvErrors;
//# sourceMappingURL=errorHandler.js.map